import axios from 'axios'
import router from "@/router";
import { Message } from 'element-ui'
import {serverIp} from "../public/config";

const request = axios.create({
    /*baseURL: `http://${serverIp}:9090`,*/
    baseURL: `http://localhost:9090`,
    timeout: 30000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers['Token'] = JSON.parse(sessionStorage.getItem('token'))
    return config
}, error => {
    return Promise.reject(error.response)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        if (response.data.code === 304){
            Message.warning('请先登录系统')
            router.push('/login')
        }
        if (response.data.success === false) {
            return Message.error(response.data)
        } else {
            return response.data
        }
    },
    error => {
        return Promise.reject(error.response) // 返回接口返回的错误信息
    }
)


export default request

